import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { base44 } from "@/api/base44Client";
import { strainSlug } from "@/lib/strainsData";

export default function ComparisonPatientOpinions({ strain, language }) {
  const pl = language === "pl";
  const { data, isPending, isError } = useQuery({
    queryKey: ["comparison-patient-opinions", strain.id],
    queryFn: async () => {
      const [experience, reviews] = await Promise.all([
        base44.entities.PatientExperience.filter({ strainId: strain.id }, { limit: 1, sort: "-updated_date", fields: ["summary", "summaryEn", "reviewCount"] }),
        base44.entities.PatientReview.filter({ strain_slug: strain.id, is_approved: true }, { limit: 3, sort: "-created_date", fields: ["content", "rating"] }),
      ]);
      return { experience: experience.items[0], reviews: reviews.items };
    },
    staleTime: 5 * 60 * 1000,
  });
  if (isPending) return <p role="status" className="text-muted-foreground">{pl ? "Ładowanie opinii…" : "Loading reviews…"}</p>;
  if (isError) return <p role="alert">{pl ? "Nie udało się pobrać opinii." : "Unable to load reviews."}</p>;
  const summary = pl ? data.experience?.summary : (data.experience?.summaryEn || data.experience?.summary);
  return (
    <div className="space-y-3">
      {summary && <div>
        <p className="font-medium mb-1">{pl ? "Podsumowanie doświadczeń" : "Experience summary"}</p>
        <p>{summary}</p>
        {data.experience.reviewCount > 0 && <p className="text-xs text-muted-foreground mt-1">{pl ? `Podsumowanie na podstawie ${data.experience.reviewCount} opinii` : `Summary based on ${data.experience.reviewCount} reviews`}</p>}
      </div>}
      {data.reviews.length > 0 && <div className="space-y-3">
        <p className="font-medium">{pl ? "Najnowsze zatwierdzone opinie (do 3)" : "Latest approved reviews (up to 3)"}</p>
        {data.reviews.map((review) => <blockquote key={review.id} className="border-l-2 border-border pl-2">
          <p className="text-xs text-muted-foreground mb-1">{pl ? "Ocena" : "Rating"}: {review.rating}/5</p>
          <p className="whitespace-pre-line">{review.content}</p>
        </blockquote>)}
      </div>}
      {!summary && !data.reviews.length && <p className="text-muted-foreground">{pl ? "Brak opinii pacjentów dla tej odmiany." : "No patient reviews for this strain."}</p>}
      <p className="text-xs text-muted-foreground">{pl ? "Subiektywne doświadczenia pacjentów, nie dowód skuteczności leczenia." : "Subjective patient experiences, not evidence of treatment efficacy."}</p>
      <Link to={`/odmiana/${strainSlug(strain)}`} className="inline-flex items-center min-h-[44px] text-primary underline underline-offset-4">{pl ? "Zobacz odmianę i opinie" : "View strain and reviews"}</Link>
    </div>
  );
}